import React from "react";
import {
    Col,
    Container,
    Row,
} from "reactstrap";

import DatacentreIsland from "../../assets/images/gallium/dc-island.png";

const Hero = () => {
    return (
        <React.Fragment>
            <section className="section job-hero-section bg-light pb-0" id="hero">
                <Container>
                    <Row className="justify-content-between align-items-center">
                        <Col lg={8}>
                            <div>
                                <h1 className="display-6 fw-bold mb-3 lh-base">
                                Gallium gives you a Cloud-like experience for running Virtual Machines on your servers 
                                </h1>
                                <p className="lead text-muted fw-normal lh-base mb-4">
                                We’re closing the effort gap between deploying VMs on Public Cloud and your own hardware. Fully managed from the Cloud across one server or thousands.  
                                </p>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className="position-relative home-img text-center mb-5 mt-lg-0">
                                <img src={DatacentreIsland} alt="" className="user-img" style={{maxWidth: "100%"}}/>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Hero;
